import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

import { Cow } from '../../models/cow.model';
import { CowService } from '../../services/cow.service';
import * as CowActions from '../actions/cow.actions';

@Injectable()
export class CowEffects {
  private readonly actions$ = inject(Actions);
  private readonly cowService = inject(CowService);

  protected loadCow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CowActions.loadCowRequest),
      mergeMap(({ internationalCowId }) =>
        this.cowService
          .getCow(internationalCowId)
          .pipe(map((cow: Cow) => CowActions.loadCowSuccess({ cow }))),
      ),
    ),
  );
}
